(() => {
  const WORKER_BASE = window.TGG_CUSTOMS_WORKER_BASE || "";
  const ROOT_ID = "tgg-customs-preview";

  function el(tag, attrs = {}, children = []) {
    const n = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === "class") n.className = v;
      else if (k === "html") n.innerHTML = v;
      else n.setAttribute(k, v);
    });
    (Array.isArray(children) ? children : [children]).forEach((c) => {      
        if (c == null) return;
      if (typeof c === "string") n.appendChild(document.createTextNode(c));
      else n.appendChild(c);
    });
    return n;
  }

  function setStatus(root, msg, kind = "info") {
    const box = root.querySelector("[data-status]");
    box.textContent = msg || "";
    box.style.color = kind === "error" ? "#b00020" : "#222";
  }

  function normalizePhone(input) {
    // v1: if they type 10 digits, assume US +1.
        // Better later: use libphonenumber.
    const digits = (input || "").replace(/[^\d]/g, "");
    if (digits.length === 10) return "+1" + digits;
    if (digits.length === 11 && digits.startsWith("1")) return "+" + digits;
    if (input.startsWith("+")) return input;
    return "+" + digits; // fallback
  }

  async function postJson(url, body) {
    const r = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const text = await r.text();
        let data = null;
    try { data = text ? JSON.parse(text) : null; } catch (e) {}
    if (!r.ok) {
      const msg = (data && (data.detail || data.error)) || text || `HTTP ${r.status}`;
      const err = new Error(msg);
      err.status = r.status;
      throw err;
    }
    return data;
  }

  async function getJson(url) {
    const r = await fetch(url);
    const text = await r.text();
    let data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) {}
    if (!r.ok) {
      const msg = (data && (data.detail || data.error)) || text || `HTTP ${r.status}`;
      const err = new Error(msg);
      err.status = r.status;
      throw err;
    }
    return data;
  }

  function renderImages(root, preview) {
    const grid = root.querySelector("[data-grid]");
    grid.innerHTML = "";

    (preview.images || []).forEach((img) => {
              const card = el("div", { class: "tgg-card" }, [
        el("div", { class: "tgg-label" }, `Option ${img.label}`),
        el("img", {
          class: "tgg-img",
          src: img.url,
          alt: `Option ${img.label}`,
          loading: "lazy",
        }),
        el("button", { class: "tgg-btn", type: "button" }, `Select ${img.label}`),
      ]);

      card.querySelector("button").addEventListener("click", async () => {
        try {
          setStatus(root, `Selecting ${img.label}...`);
          const data = await postJson(`${WORKER_BASE}/api/preview/${encodeURIComponent(preview.previewId)}/select`, {
                        label: img.label,
          });
          if (data && data.depositUrl) {
            window.location.href = data.depositUrl;
          } else {
            setStatus(root, "Select succeeded but no deposit URL returned.", "error");
          }
        } catch (e) {
          setStatus(root, `Select failed: ${e.message}`, "error");
        }
      });

      grid.appendChild(card);
    });
  }
    function mount() {
    const root = document.getElementById(ROOT_ID);
    if (!root) return;

    root.innerHTML = "";
    root.appendChild(el("style", { html: `
      #${ROOT_ID} { font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; max-width: 960px; margin: 0 auto; padding: 20px; }
      .tgg-box { border: 1px solid #e5e5e5; border-radius: 12px; padding: 16px; background: #fff; }
      .tgg-row { display:flex; gap: 12px; flex-wrap: wrap; align-items: end; }
      .tgg-row label { display:block; font-size: 13px; margin-bottom: 6px; color:#333; }
      .tgg-input { width: 260px; padding: 10px 12px; border: 1px solid #ccc; border-radius: 10px; font-size: 16px; }
      .tgg-btn { padding: 10px 14px; border-radius: 10px; border: 1px solid #111; background:#111; color:#fff; cursor:pointer; font-weight:600; }
      .tgg-btn:disabled { opacity: .6; cursor: not-allowed; }
      .tgg-status { margin-top: 10px; min-height: 20px; font-size: 14px; }
            .tgg-grid { margin-top: 18px; display:grid; grid-template-columns: repeat(2, minmax(0,1fr)); gap: 14px; }
      @media (max-width: 720px) { .tgg-grid { grid-template-columns: 1fr; } }
      .tgg-card { border: 1px solid #eee; border-radius: 12px; padding: 12px; }
      .tgg-label { font-weight: 700; margin-bottom: 8px; }
      .tgg-img { width: 100%; height: auto; border-radius: 10px; border: 1px solid #f0f0f0; margin-bottom: 10px; }
      .tgg-note { font-size: 13px; color:#555; margin-top: 8px; }
    `}));

    const box = el("div", { class: "tgg-box" }, [
      el("h2", {}, "Find your clean pendant designs"),
      el("div", { class: "tgg-note" },
        "Enter the phone number you used when you unlocked your designs. We’ll show your latest set."
      ),
      el("div", { class: "tgg-row" }, [
        el("div", {}, [
                      el("label", { for: "tgg-phone" }, "Phone number"),
          el("input", { id: "tgg-phone", class: "tgg-input", placeholder: "(555) 555-5555" }),
        ]),
        el("button", { class: "tgg-btn", type: "button", id: "tgg-find" }, "Find my designs"),
      ]),
      el("div", { class: "tgg-status", "data-status": "1" }, ""),
      el("div", { class: "tgg-grid", "data-grid": "1" }, ""),
    ]);

    root.appendChild(box);

    const btn = root.querySelector("#tgg-find");
    btn.addEventListener("click", async () => {
      if (!WORKER_BASE) {
        setStatus(root, "Worker base URL missing (TGG_CUSTOMS_WORKER_BASE).", "error");
                return;
      }
      const phoneRaw = root.querySelector("#tgg-phone").value;
      const phone = normalizePhone(phoneRaw);

      btn.disabled = true;
      try {
        setStatus(root, "Looking up your latest designs...");
        const data = await postJson(`${WORKER_BASE}/api/preview/lookup`, { phone });
        if (!data || !data.images || data.images.length === 0) {
          setStatus(root, "No unlocked designs found for that phone number yet.", "error");
          return;
        }
        setStatus(root, "Select the option you like best:");
        renderImages(root, data);
              } catch (e) {
        if (e.status === 429) {
          setStatus(root, "Too many attempts. Please wait a bit and try again.", "error");
        } else {
          setStatus(root, `Lookup failed: ${e.message}`, "error");
        }
      } finally {
        btn.disabled = false;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", mount);
})();